<script setup>
import { onMounted, ref, computed } from "vue";
import {COZE_TOKEN} from "@/constant";
import { useStore } from 'vuex'

const store = useStore()

const cozeIcon = 'https://obs-user-test.obs.cn-east-3.myhuaweicloud.com:443/pictures/test_1747025867_0kFMwpjLOL.png'

const coze = ref(null)

const cozeAccessToken = computed(() => store.state.cozeAccessToken)
const cozeInit = () => {
	coze.value = new CozeWebSDK.WebChatClient({
		config: {
			bot_id: '7501206380289097738',
		},
		componentProps: {
			title: '智能客服',
		},
		auth: {
			type: 'token',
			token: cozeAccessToken.value,
			onRefreshToken: function () {
				return cozeAccessToken.value
			}
		},
		ui: {
			base: {
				icon: cozeIcon
			},
			footer: {
				isShow: false
			},
			chatBot: {
				uploadable: false
			},
			asstBtn: {
				isNeed: false
			}
		}
	});
}

const handleOpenChatBot = async () => {
	if (store.getters.cozeExpireTime > Math.floor(Date.now() / 1000)) {
		coze.value.showChatBot()
	} else {
		await store.dispatch('getCozeAccessToken')
		coze.value.showChatBot()
	}
	
}

onMounted(() => {
	cozeInit()
})
</script>

<template>
	<div
		class="smart-customer-service"
		@click="handleOpenChatBot"
	>
		<SvgIcon name="customer-service" class-name="icon" />
		
		<div class="title">智能客服</div>
	</div>
</template>

<style scoped lang="less">
.smart-customer-service {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	position: fixed;
	right: 60px;
	top: 80%;
	z-index: 999;
	padding: 10px 16px;
	//width: 80px;
	//height: 80px;
	transition: all .3s;
	background: linear-gradient( 157deg, #F46760 0%, #D1170E 100%), #FFFFFF;
	box-shadow: 8px 8px 20px 0px rgba(199,68,68,0.3);
	border-radius: 16px;
	
	.icon {
		width: 48px;
		height: 48px;
	}
	
	.title {
		color: #FFFFFF;
		line-height: 24px;
	}
	
	&:hover {
		cursor: pointer;
		transform: scale(1.2);
	}
	
	.coze-icon {
		width: 100%;
		height: 100%;
	}
}
</style>